/* Important Info component for the Character Edit page */
import React from 'react';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "../../styles/Callsheets.module.css";
import { useCurrentUser } from '../../contexts/CurrentUserContext';

const InfoEdit = () => {
  const currentUser = useCurrentUser();
  return (
    <div className="mb-5">
        <Row className="mb-2">
        <Col md={{span: 8, offset: 2}}>
        <div className={`px-3 pt-1 pb-2 ${styles.SubTitle6 }`}>
        <h5 className={`text-center ${styles.Red }`} >INFO</h5>  
        <hr className={`mt-2 mb-0`}/>
        {currentUser &&
              currentUser?.groups.length > 0 &&
              (currentUser?.groups[0]?.name === "Admin" ||
                currentUser?.groups[0]?.name === "Superadmin") && (
        <p className={`pt-2 text-center`}>
          <span className={`${styles.Red}`}>*</span> On <span className={`${styles.Red}`}>registering</span> the Actor add their details here 
          and add the Callname in Manage Users.
          </p>
                )}
        <p className={`pt-2 text-center`}>
          <span className={`${styles.Red}`}>*</span> Add the Character <span className={`${styles.Red}`}>Makeup & Costume</span> details and images in the Makeup & Costumes section below.
          </p>
          <hr className={`mt-2 mb-0`}/>
         </div> 
        </Col>
      </Row>
    </div>
  )
}

export default InfoEdit